import {Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
  
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: string, lang :string): unknown {
    const time = value.split(':')[0];
    if (+time > 12){
      return `${+time - 12}:${value.split(':')[1]} ${ lang === 'en' ? 'PM' : 'م'}`;
    }
    if (+time < 12){
      return `${+time}:${value.split(':')[1]}  ${ lang === 'en' ? 'AM' : 'ص'}`;
    }
    if (+time === 12){
      return `${+time}:${value.split(':')[1]} ${ lang === 'en' ? 'PM' : 'م'}`;
    }
    if (time === '00'){
      return `${'12'}:${value.split(':')[1]}  ${ lang === 'en' ? 'AM' : 'ص'}`;
    }
    else{
      return value;
    }
  }

}
